import { downloadCsv } from "../utils/downloadFile";

export const handleDownload = async (
  processedCsvPath?: string,
  outputFileName?: string,
): Promise<void> => {
  if (!processedCsvPath) {
    console.error("No CSV path available for download");
    return;
  }
  try {
    await downloadCsv(processedCsvPath, outputFileName);
  } catch (error) {
    console.error("Failed to download CSV:", error);
  }
};
